export default __webpack_public_path__ + "static/media/qms_pdf_icon.cada2e94.svg";